// extracted by mini-css-extract-plugin
module.exports = {"chip":"upUWtGFwUL5qbf0OsjBz"};